import { useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';
import {
  getDailyTimeRangeOptions,
  getMonthlyTimeRangeOptions,
  getWeeklyTimeRangeOptions,
  getYearlyTimeRangeOptions,
} from '../const';

import { CustomReportModalFormikValues, TIMEFRAME } from '../types';
import { CustomTimeframe } from './CustomTimeframe';
import { SelectTimeframe } from './SelectTimeframe';
import { TimeframeGroup } from './TimeframeGroup';
import { getDefaultTimeframeValue } from './utils';
import { useTranslation } from 'react-i18next';
import { PillItem } from 'lib/components/SegmentedControl/types';

interface IProps {
  updateRangeValue: (rangeValue: string) => void;
  currentRangeValue: string;
  timeframeOptions: PillItem[];
}

export const Timeframe = ({
  currentRangeValue,
  updateRangeValue,
  timeframeOptions,
}: IProps) => {
  const { t } = useTranslation();
  const { values } = useFormikContext<CustomReportModalFormikValues>();

  const [currentTimeframe, setCurrentTimeFrame] = useState<TIMEFRAME>(
    getDefaultTimeframeValue(currentRangeValue)
  );

  useEffect(() => {
    const newTab = getDefaultTimeframeValue(currentRangeValue);
    setCurrentTimeFrame(newTab);
  }, [values.staticRange, values.reccuringRange]);

  return (
    <>
      <SelectTimeframe
        setCurrentTimeFrame={setCurrentTimeFrame}
        currentTimeframe={currentTimeframe}
        updateRangeValue={updateRangeValue}
        timeframeOptions={timeframeOptions}
      />
      {currentTimeframe === TIMEFRAME.DAY && (
        <TimeframeGroup
          options={getDailyTimeRangeOptions(t)}
          currentRangeValue={currentRangeValue}
          updateRangeValue={updateRangeValue}
        />
      )}
      {currentTimeframe === TIMEFRAME.WEEK && (
        <TimeframeGroup
          options={getWeeklyTimeRangeOptions(t)}
          currentRangeValue={currentRangeValue}
          updateRangeValue={updateRangeValue}
        />
      )}
      {currentTimeframe === TIMEFRAME.MONTH && (
        <TimeframeGroup
          options={getMonthlyTimeRangeOptions(t)}
          currentRangeValue={currentRangeValue}
          updateRangeValue={updateRangeValue}
        />
      )}
      {currentTimeframe === TIMEFRAME.YEAR && (
        <TimeframeGroup
          options={getYearlyTimeRangeOptions(t)}
          currentRangeValue={currentRangeValue}
          updateRangeValue={updateRangeValue}
        />
      )}
      {currentTimeframe === TIMEFRAME.CUSTOM && <CustomTimeframe />}
    </>
  );
};
